import { useFormContext } from "react-hook-form";
import { FieldError } from "./form/Field";

const policies = [
  "I understand that the failure of a camper to maintain such standards or failure to properly participate in camp activities or maintain befitting discipline and conduct may result in suitable and reasonable punishment, including expulsion from the camp, at my expense without any refund of fees paid.",
  "I hereby waive any and all claims, against the Sikh Center and its volunteers, arising to take whatever action they feel is warranted under the circumstances in regard to my child(ren)’s health and safety, including securing medical treatment (at my own or my child[ren]’s expense). I further release any of these persons from any liability for such decisions or actions, which may be taken on my behalf.",
  "I understand that campers must respect the facility and leave it in the way they found it at the beginning of the camp. I will be liable to pay a fee as set forth by the organizers if (any of) my child(ren) bring(s) any damage to the room or facility that my child(ren) will be using. All of the campers in each room are all responsible for that room. The damages fee will be divided among all of the campers in that particular room in question",
  "If cancellation occurs after Dec 18th, no refunds will be offered. Before Dec 18th, 50% of the registration fee will be returned.",
  "During the stay at Houston Sikh Youth Camp, various volunteer doctors will be assisting my child(ren) with various minor ailments. I have fully disclosed all relevant allergies or medical conditions to the Houston Sikh Youth Camp. I will not hold the doctors professionally or personally liable for the administration of medicine or any health care during the duration of the camp.",
  "I hereby consent that my child(ren)’s picture/video may be taken and used to promote the Sikh Center and Houston Sikh Youth Camp, and/or its programs.",
];

export default function ReigstrationAgreement() {
  const { register } = useFormContext();

  return (
    <ul className="reg-policies">
      {policies.map((text, i) => {
        const name = `agreement.argreement_section${i + 1}`;
        return (
          <li key={name}>
            <label className="reg-policy">
              <input type="checkbox" {...register(name, { required: "Check this box to agree." })} />
              <span>{text}</span>
            </label>
            <FieldError name={name} />
          </li>
        );
      })}
    </ul>
  );
}
